import React from "react";
import { useParams } from "react-router-dom";

import PageContent from "2g-page-content";

import ProvozniInformaceDetailWidget from "b2b/components/provozni-informace-detail-widget";

function ProvozniInformaceDetail() {
  const { id } = useParams();
  return (
    <PageContent>
      <ProvozniInformaceDetailWidget id={id} />
    </PageContent>
  );
}

export default React.memo(ProvozniInformaceDetail);
